import type { IconType } from "@circle-react-shared/Icon";
import { Icon } from "@circle-react-shared/Icon";

interface TextModifierIconProps {
  className?: string;
  iconSize?: number;
  type: IconType;
}

export const TextModifierIcon = ({
  type,
  iconSize = 20,
  className,
}: TextModifierIconProps) => (
  <span className="flex items-center">
    <Icon
      type={type}
      size={iconSize}
      className={className}
      useWithFillCurrentColor
    />
  </span>
);
